import { throwIfAborted } from '../abort.js';
import { isFundingMethod } from '../discovery/policy.js';
import { fetchHistoryWithCooldown } from './history-query.js';
/** Only backend-confirmed deliveries qualify; no provider wallet credentials are read. */
export async function fetchSavedFundingMethods(client, signal) {
    const methods = new Set();
    let cursor;
    // This is a recent-method shortcut, not a complete history scan. Reserve the
    // shared read budget for checkout and the user's actual history screen.
    for (let pageIndex = 0; pageIndex < 2 && methods.size < 2; pageIndex += 1) {
        throwIfAborted(signal);
        const page = await fetchHistoryWithCooldown(client, { status: 'delivered', limit: 50, ...(cursor ? { cursor } : {}) }, signal);
        for (const operation of page.data) {
            if (operation.status === 'delivered' &&
                !operation.withdrawal &&
                isFundingMethod(operation.method))
                methods.add(operation.method);
        }
        if (!page.hasMore)
            break;
        if (!page.nextCursor || page.nextCursor === cursor)
            throw new Error('onramp_history_cursor_invalid');
        cursor = page.nextCursor;
    }
    return [...methods];
}
